import { atom } from "jotai";

export const modalState = atom({
  type: "complete",
  show: false,
  msg: "",
  closeCallback: null,
});

export const unlockState = atom({
  show: false,
  data: null,
});

export const settingState = atom({
  show: false,
});
